import { render, staticRenderFns } from "./AchievementsPanel.vue?vue&type=template&id=7456cf4e&scoped=true&"
import script from "./AchievementsPanel.vue?vue&type=script&lang=js&"
export * from "./AchievementsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7456cf4e",
  null
  
)

export default component.exports